function Contact() {
    window.scrollTo(0,0);
    return (
        <>
        <div
      className="container-fluid page-header py-5 mb-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <h1 className="display-4 animated slideInDown mb-4">Contact Us</h1>
        {/* <nav aria-label="breadcrumb animated slideInDown">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Pages</a></li>
            <li class="breadcrumb-item active" aria-current="page">About</li>
          </ol>
        </nav> */}
      </div>
    </div>
    {/* <!-- Contact Start --> */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
            <h1 className="display-6 mb-5">
              If You Have Any Query, Please Contact Us
            </h1>
            <p className="mb-4">
            Contact us today to learn more about our insurance services and solutions..
            </p>
            <form>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                    />
                    <label htmlFor="name">Your Name</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your Email"
                    />
                    <label htmlFor="email">Your Email</label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      placeholder="Subject"
                    />
                    <label htmlFor="subject">Subject</label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Leave a message here"
                      id="message"
                      style={{height: "100px"}}
                    ></textarea>
                    <label htmlFor="message">Message</label>
                  </div>
                </div>
                <div className="col-12">
                  <button className="btn btn-primary py-3 px-5" type="submit">
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div
            className="col-lg-6 wow fadeIn"
            data-wow-delay="0.5s"
            style={{minHeight: "450px"}}
          >
            <div className="position-relative rounded overflow-hidden h-100">
              <iframe
                className="w-100 h-100"
                //src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.0316276546932!2d72.83083307336393!3d18.9299941565436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1c3674fffff%3A0x5bd498381887d2ad!2sBSE%20Startups!5e0!3m2!1sen!2sin!4v1738065513588!5m2!1sen!2sin"
                src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Suraksha%20Ace%2C%20Village%20Chakala%2C%C2%A0Mumbai%C2%A0400059&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                frameborder="0"
                style={{minHeight: "450px", border: "0"}}
                allowfullscreen=""
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- Contact End --> */}


        </>
    )
}
export default Contact;